import { useTranslation } from "react-i18next";

import { Page } from "@components/atoms/page";
import { Subtitle } from "@components/atoms/subtitle";
import { useTableParams } from "@components/organisms/pageTable";
import type { IAppointmentVisitTypes } from "@api/appointment";
import { useAppointmentTable } from "@api/appointment";
import { Statistics } from "@components/organisms/statistics";
import { DashboardSummary } from "@components/molecules/dashboardSummary";
import { Separator } from "@components/atoms/separator";
import { useDashboard } from "@api/dashboard";
import { AppointmentTable } from "@/templates/appointmentManagement";

export function Component() {
  const { t } = useTranslation("common");

  const { paginationValues, searchValue, filterValues, tableProps } =
    useTableParams({
      tabs: [
        { key: "online_visit", title: t("pageTitle.onlineVisits") },
        { key: "in_person_visit", title: t("pageTitle.inPersonVisits") },
      ],
    });
  const { currentPage, resultsPerPage } = paginationValues;

  const { data, isLoading, isFetching, isError } = useAppointmentTable({
    variables: {
      page: currentPage,
      per_page: resultsPerPage,
      filter: searchValue,
      visit_types: [
        (tableProps?.tabProps?.selectedKey as IAppointmentVisitTypes) ||
          "online_visit",
      ],
      time: "today",
      ...filterValues,
    },
  });

  const {
    data: dashboardData,
    isLoading: isDashboardLoading,
    isError: isDashboardError,
  } = useDashboard();

  const stats = data?.data?.statistics;

  return (
    <Page>
      <DashboardSummary
        items={dashboardData?.data || []}
        isLoading={isDashboardLoading}
        isError={isDashboardError}
      />
      <Separator />
      <Subtitle title={"visits_today"} />
      <Statistics data={stats || []} isLoading={isLoading} isError={isError} />
      <AppointmentTable
        type={"all"}
        data={data?.data?.page?.list || []}
        total={data?.data?.page?.total || 0}
        isLoading={isLoading}
        isFetching={isFetching}
        tableParamProps={tableProps}
        isError={isError}
      />
    </Page>
  );
}
